import { render, staticRenderFns } from "./approvalTime.vue?vue&type=template&id=40f7d6ff&scoped=true&"
import script from "./approvalTime.vue?vue&type=script&lang=js&"
export * from "./approvalTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f7d6ff",
  null
  
)

export default component.exports